var jQuery = require('jquery');
var _ = require('lodash');
var InputField = require('ub/ui/properties-panel/input-field');

var EmailActionFields = function(options) {
  this.onActivate = options.onActivate;
  this.uiBinding = options.uiBinding;

  this.emailAddressField = new InputField({
    label: 'Email Address',
    placeholder: 'e.g: bob@youremail.com',
    changeHandler: function(e) {
      this.uiBinding.onNext({
        type: 'changeEmailAddress',
        value: e.target.value
      });
    }.bind(this)
  });

  this.emailSubjectField = new InputField({
    label: 'Email Subject',
    placeholder: 'e.g: You\'ve got mail!',
    changeHandler: function(e) {
      this.uiBinding.onNext({
        type: 'changeEmailSubject',
        value: e.target.value
      });
    }.bind(this)
  });

  this.setVisible(false);

  jQuery(options.container).append([
    this.emailAddressField.inputContainer,
    this.emailSubjectField.inputContainer
  ]);

};

EmailActionFields.prototype = {
  setValue: function(newValue) {
    this.setEmailAddress(newValue.emailAddress);
    this.setEmailSubject(newValue.emailSubject);
  },

  setEmailAddress: function(newValue) {
    this.emailAddressField.setValue(newValue || this.emailAddressField.value || '');
  },

  setEmailSubject: function(newValue) {
    this.emailSubjectField.setValue(newValue || this.emailSubjectField.value || '');
  },

  setVisible: function(visible) {
    if (visible) {
      this.emailAddressField.show();
      this.emailSubjectField.show();
    } else {
      this.emailAddressField.hide();
      this.emailSubjectField.hide();
    }
  },

  activate: function() {
    this.setVisible(true);

    if (_.isFunction(this.onActivate)) {
      this.onActivate(this);
    }
  },

  deactivate: function() {
    this.setVisible(false);
  }
};

module.exports = EmailActionFields;



// WEBPACK FOOTER //
// ./src/ui/properties-panel/email-action-fields.js